import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPorkHerdDetails, getPorkHerdDetailsAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, FOOTPRINTING_PORK_HERD_DETAILS } from "consts";

export const useGetFootprintingPorkHerdDetails = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_HERD_DETAILS, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getPorkHerdDetailsAdmin(primaryDataId) : getPorkHerdDetails(primaryDataId)),
      enabled: options?.enabled !== false && !!primaryDataId,
      gcTime: DEFAULT_CACHE_TIME,
      staleTime: DEFAULT_CACHE_TIME,
    },
    queryClient
  );
};
